module.exports = __webpack_public_path__ + "img/we-chat-friends.3ae510fc.svg";